<div class="container-fluid">
  <page-header-breadcrumb
    [pageTitleValue]="pageTitle"
    [pageLinkValue]="'/services'"
    [currentPageValue]="editMode ? 'Edit Service' : 'Add Service'"
  ></page-header-breadcrumb>
  <div class="card mb-4">
    <div class="card-body">
      <form [formGroup]="addServiceForm" (ngSubmit)="onAddServiceSubmit()">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="service-name">
                Service English Name
              </label>
              <input
                class="form-control"
                id="service-name"
                formControlName="enServiceName"
                placeholder="service English Name"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited || addServiceForm.controls.enServiceName.dirty) &&
                  addServiceForm.controls.enServiceName.errors
                "
                class="input-errors"
              >
                <p
                  *ngIf="addServiceForm.controls.enServiceName.errors.required"
                >
                  This field is required!
                </p>
                <p *ngIf="addServiceForm.controls.enServiceName.errors.pattern">
                  This field accept only English characters!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="service-name">
                Service Arabic Name
              </label>
              <input
                class="form-control"
                id="service-ar-name"
                formControlName="arServiceName"
                placeholder="service Arabic Name"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited || addServiceForm.controls.arServiceName.dirty) &&
                  addServiceForm.controls.arServiceName.errors
                "
                class="input-errors"
              >
                <p
                  *ngIf="addServiceForm.controls.arServiceName.errors.required"
                >
                  This field is required!
                </p>
                <p *ngIf="addServiceForm.controls.arServiceName.errors.pattern">
                  This field accept only arabic characters!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="service-name">
                Service English Description
              </label>
              <input
                class="form-control"
                id="desc-en-name"
                formControlName="enServiceShortDescription"
                placeholder="Service English Description"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited ||
                    addServiceForm.controls.enServiceShortDescription.dirty) &&
                  addServiceForm.controls.enServiceShortDescription.errors
                "
                class="input-errors"
              >
                <p
                  *ngIf="
                    addServiceForm.controls.enServiceShortDescription.errors
                      .required
                  "
                >
                  This field is required!
                </p>
                <p
                  *ngIf="
                    addServiceForm.controls.enServiceShortDescription.errors
                      .pattern
                  "
                >
                  This field accept only English characters!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="service-name">
                Service Arabic Description
              </label>
              <input
                class="form-control"
                id="desc-ar-name"
                formControlName="arServiceShortDescription"
                placeholder="Service Arabic Description"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited ||
                    addServiceForm.controls.arServiceShortDescription.dirty) &&
                  addServiceForm.controls.arServiceShortDescription.errors
                "
                class="input-errors"
              >
                <p
                  *ngIf="
                    addServiceForm.controls.arServiceShortDescription.errors
                      .required
                  "
                >
                  This field is required!
                </p>
                <p
                  *ngIf="
                    addServiceForm.controls.arServiceShortDescription.errors
                      .pattern
                  "
                >
                  This field accept only arabic characters!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 d-flex align-items-center">
            <label class="mr-6 mb-0" for="anon-check">Se7etak Service?</label>
            <label class="custom-toggle custom-toggle-default">
              <input
                type="checkbox"
                id="se7etak-check"
                formControlName="serviceType"
              />
              <span
                class="custom-toggle-slider rounded-circle"
                data-label-off="No"
                data-label-on="Yes"
              >
              </span>
            </label>
          </div>
          <div class="col-md-6 d-flex align-items-center">
            <label class="mr-6 mb-0" for="anon-check">Latest Service?</label>
            <label class="custom-toggle custom-toggle-default">
              <input
                type="checkbox"
                id="latest-check"
                formControlName="serviceStatus"
              />
              <span
                class="custom-toggle-slider rounded-circle"
                data-label-off="No"
                data-label-on="Yes"
              >
              </span>
            </label>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="service-route">
                Choose the Route
              </label>
              <select
                formControlName="serviceRoute"
                class="form-control"
                id="service-route"
                (change)="routeChanged($event.target.value)"
              >
                <option *ngFor="let route of routes" [value]="route.id">
                  {{ route.pageName }}
                </option>
              </select>
              <div
                *ngIf="
                  isSubmited && addServiceForm.controls.serviceRoute.errors
                "
                class="input-errors"
              >
                <p *ngIf="addServiceForm.controls.serviceRoute.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="rankFormControl">
                Rank
              </label>
              <select
                formControlName="serviceRank"
                class="form-control"
                id="rankFormControl"
              >
                <option
                  *ngFor="let item of ranks; let i = index"
                  [value]="i + 1"
                >
                  {{ i + 1 }}
                </option>
              </select>
              <div
                *ngIf="isSubmited && addServiceForm.controls.serviceRank.errors"
                class="input-errors"
              >
                <p *ngIf="addServiceForm.controls.serviceRank.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label class="form-control-label">Service Banner</label>
              <div
                class="icon-image-placeholder placeholder"
                id="placeholder"
                (click)="onImageUpload($event)"
                accept=".jpg,.png"
                name="img"
              ></div>
              <input
                type="hidden"
                name="fileHidden"
                formControlName="serviceFileInput"
              />
              <div
                *ngIf="
                  isSubmited && addServiceForm.controls.serviceFileInput.errors
                "
                class="input-errors"
              >
                <p
                  *ngIf="
                    addServiceForm.controls.serviceFileInput.errors.required
                  "
                >
                  This field is required!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col btns-block">
            <button class="btn btn-primary" type="submit" [disabled]="addServiceForm.invalid">
              {{ editMode ? "Edit" : "Save" }}
            </button>
            <button
              class="btn btn-outline-danger"
              type="button"
              [routerLink]="'/services'"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<ngx-spinner></ngx-spinner>
